import React from 'react';
import { connect } from 'react-redux';
import objectAssign from 'object-assign';
import { hasPermissionWA } from 'businessLogic/checkExistOrVerifyPermissions';
import { clone } from '../reducers/helper';
import { isAnyOverlayFormVisible, isAnyInputFormVisible } from 'businessLogic/form';
import { closeModalsForWAManageUsers } from 'actions/modal';
import { updateFetchingWA } from 'actions/waitingArea';
import WaitingAreaManageUsersContent from '../components/pages/waiting-area/manage-users/content';
import NotFoundPage from './NotFoundPage.js';

@connect(mapStateToProps)
export default class WaitingAreaManageUsersPage extends React.Component {
  constructor(props) {
    super(props);
  }

  UNSAFE_componentWillMount() {
    //Set getting waiting area = {} to force fetching waiting area info
    this.props.dispatch(updateFetchingWA({}));
  }

  render() {
    // permissions check
    if (this.props.redirectToPageNotFound || !this.props.hasWaitingAreas || this.props.canAccess == false) {
      return <NotFoundPage dispatch={this.props.dispatch} preAction={closeModalsForWAManageUsers} />;
    }

    return (
      <WaitingAreaManageUsersContent
        id={parseInt(this.props.match.params.id)}
        waitingArea={this.props.waitingArea}
        usersIcanManage={this.props.usersIcanManage}
        searchTerm={this.props.searchTerm}
        userId={this.props.userId}
        dispatch={this.props.dispatch}
        availableRoles={this.props.availableRoles}
        showManageRolesForUsersModal={this.props.showManageRolesForUsersModal}
        fetchingUserICanManage={this.props.fetchingUserICanManage}
        showWaitingAreaAddUsersModal={this.props.showWaitingAreaAddUsersModal}
        timezone={this.props.timezone}
        previousPage={this.props.previousPage}
      />
    );
  }
}

function mapStateToProps(state, props) {
  let selectedWaitingArea = state.waitingAreaReducer.cleanWaitingArea;
  let usersIcanManageInThisWaitingArea = [];
  let availableRoles = [];

  if (!!state.waitingAreaReducer.selectedWaitingAreaId) {
    const selectedWaitingAreaId = state.waitingAreaReducer.selectedWaitingAreaId;
    selectedWaitingArea = state.waitingAreaReducer.waitingAreas.find((wa) => wa.id === selectedWaitingAreaId);

    if (!!selectedWaitingArea) {
      availableRoles = selectedWaitingArea.availableRoles;
    }

    if (state.usersReducer.usersIcanManage && state.usersReducer.usersIcanManage.length > 0) {
      usersIcanManageInThisWaitingArea = state.usersReducer.usersIcanManage;
    }
  }
  let networkId = props.match.params.id;
  // Necessary code to check permission
  let fetchingWaitingArea = state.waitingAreaReducer.fetchingWaitingArea;
  let canAccess = fetchingWaitingArea === false ? hasPermissionWA(state, networkId, 'MANAGE_MEMBER_ROLES') : true;

  const waitingArea = objectAssign({}, state.waitingAreaReducer.cleanWaitingArea, selectedWaitingArea);

  return {
    redirectToPageNotFound: state.sharedReducer.redirectToPageNotFound,
    waitingArea: waitingArea,
    usersIcanManage: usersIcanManageInThisWaitingArea,
    searchTerm: state.waitingAreaReducer.currentWaitingAreaMemberFilter || '',
    showWaitingAreaAddUsersModal: state.modalReducer.showWaitingAreaAddUsersModal,
    hasWaitingAreas: state.usersReducer.userProfile.hasWaitingAreas,
    availableRoles: availableRoles,
    showManageRolesForUsersModal: state.modalReducer.showManageRolesForUsersModal,
    timezone: state.usersReducer.userProfile.timezoneOffsetNow,
    userId: state.usersReducer.userProfile.id,
    canAccess: canAccess,
    previousPage: state.navigationBarReducer.previousPage,
  };
}
